/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ResizeObserver from 'react-resize-observer';
import {
  animated,
  useSpring,
  useTransition,
  easings,
} from 'react-spring';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { useTheme } from 'emotion-theming';
import Shimmer from '../../../../shared/_TBComponents/Shimmer';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/components/Text/Text';
import WarmUpExercisesContainer from './WarmUpExercisesContainer';
import SACQContainer from './SACQContainer';
import CircuitsContainer from './CircuitsContainer';
import LiftExercisesContainer from './LiftExercisesContainer';
import NotesContainer from './NotesContainer';
import QuestionnairesContainer from './QuestionnairesContainer';
import ExerciseDataBaseButton from './ExerciseDataBaseButton';
import CooldownContainer from './CooldownContainer';
import HealthContainer from './HealthContainer';
import ProgressionsContainer from './ProgressionsContainer';
import TagsContainer from './TagsContainer';
import { setActiveModal, setSecondarySideBarDataTag, setSideBarExerciseSearchTerm } from '../../ducks/calendarActions';
import AccessoryDraggableItemsContainer from './AccessoryDraggableItemsContainer';
import SideBarTitleWrapper from './SideBarTitleWrapper';

const Wrapper = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  background: ${({ theme }) => theme.colors.surface};
  position: relative;
`;

const TitleContainer = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  align-items: flex-start;
`;

/** commenting out search related code for now, we will need this down the road */
/**
const SearchAndIcon = styled('div')`
  display: flex;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 4px;
  background: white;
  overflow: hidden;
  width: 100%;
  min-height: 32px;
`;
*/

/**
const SearchIconContainer = styled('div')`
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5px;
  height: 40px;
`;
*/

/**
const SearchContainer = styled('input')`
  display: flex;
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.text};
  padding-left: 5px;
  width: 100%;
  height: 40x;

  ::placeholder {
  font-size: 16px;
  font-family: 'Nunito Sans';
  color: #9E9E9E;
}
`;
*/

const ExerciseWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  max-height: ${(props) => props.sideBarContainerHeight - 100 - props.expandedTitlesContainerHeight}px;
 /** commenting this height calc out for now, we will need it if we choose to uncomment the search bar down the road */
 /** max-height: ${(props) => props.sideBarContainerHeight - 160 - props.expandedTitlesContainerHeight}px; */
  overflow: auto;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(136, 136, 136, 0.5);
    border-radius: 10px;
    transition: background-color 0.3s ease; 
  }
  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0); 
  }
  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(136, 136, 136, 1); 
  }
  scrollbar-width: thin; 
  scrollbar-color: rgba(136, 136, 136, 0.5) transparent;
`;

const ExerciseItemContainer = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  transition: all 250ms ease-in-out;
  ${(props) => props.addBorderTop && `border-top: 1px solid ${props.theme.colors.borderLight}`};
  ${(props) => props.addBorderTop && 'padding-top: 12px'};
  :hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const Separator = styled('div')`
  border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  margin-top: 8px;
  margin-bottom: 8px;
`;

const ExerciseItemShimmerStrip = styled('div')`
  display: flex;
  width: 100%;
  min-height: 32px;
  border-radius: 4px;
`;

const ExerciseNameAndIconWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IconBox = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 4px;
  ${(props) => props.borderColor && `border: 1px solid ${props.borderColor}`};
`;

const AnimationWrapper = styled('div')`
  display: flex;
  gap: 16px;
  width: 100%;
  height: 100%;
`;

const MappedComponents = styled('div')`
  display: flex;
  flex-direction: column;
`;

const SearchedExercisesContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ExpandedTitlesContainer = styled('div')`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-wrap: wrap;
`;

const HoverTextContainer = styled('div')`
  display: flex;
  :hover {
      cursor: pointer;
      opacity: 0.7;
    }
`;

const ExercisesSideBarContent = ({
  windowWidth, sideBarContainerHeight, sideBarContainerWidth,
}) => {
  const dispatch = useDispatch();
  const expandedTitlesContainerHeightRef = useRef(null);
  const resizeTimer = useRef(null);
  /** commenting search bar related state out for now, we might need it for future functionality */
  // eslint-disable-next-line no-unused-vars
  const [searchTerm, setSearchTerm] = useState('');
  /** const [isSearchFocused, setIsSearchFocused] = useState(false); */
  const [containerWidth, setContainerWidth] = useState(0);
  const [expandedTitlesContainerHeight, setExpandedTitlesContainerHeight] = useState(0);
  const [isResizing, setIsResizing] = useState(false);
  const [showTagFilterDropdown, setShowTagFilterDropdown] = useState(false);
  const [showSecondLayerInfo, setShowSecondLayerInfo] = useState(false);
  const [showThirdLayerInfo, setShowThirdLayerInfo] = useState(false);
  const isAllExercisesLoading = useSelector((state) => state.calendar.ui.isAllExercisesLoading);
  const primarySideBarDataTag = useSelector((state) => state.calendar.data.primarySideBarDataTag);
  const secondarySideBarDataTag = useSelector((state) => state.calendar.data.secondarySideBarDataTag);
  /** will need this later for search functionality */
  const accessoryItems = useSelector((state) => state.calendar.data.calendarItemContainers.accessoryCalendarItems);
  const { colors } = useTheme();

  useEffect(() => {
    const updateHeight = () => {
      if (expandedTitlesContainerHeightRef.current) {
        const rect = expandedTitlesContainerHeightRef.current.getBoundingClientRect();
        setExpandedTitlesContainerHeight(rect.height);
      }
    };
    /** Update height on mount */
    updateHeight();
    /** Optional: Update height on window resize or other triggers */
    window.addEventListener('resize', updateHeight);

    /** Cleanup event listener on unmount */
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, [showSecondLayerInfo, showThirdLayerInfo]);

  /** Track resize events using window.onresize */
  useEffect(() => {
    /** Handler function to manage resizing state */
    const handleResize = () => {
      setIsResizing(true);
      clearTimeout(resizeTimer.current);

      /** Set resizing state back to false after resize ends */
      resizeTimer.current = setTimeout(() => {
        setIsResizing(false);
      }, 200); /** Adjust timeout duration as needed */
    };

    /** Assign the handler to window.onresize */
    window.onresize = handleResize;

    /** Clean up by removing the handler */
    return () => {
      window.onresize = null;
    };
  }, []);

  /** commenting search funtionality out for now, we might need it for future functionality */
  /**
  useEffect(() => {
    dispatch(setSideBarExerciseSearchTerm(searchTerm));
  }, [searchTerm]);
  */

  useEffect(() => {
    const handleKeyDown = (e) => {
      /** Check if Shift + Enter are pressed */
      if (e.shiftKey && e.key === 'Enter') {
        /** Trigger the 'Create New Exercise' logic */
        if (primarySideBarDataTag === 'lift' && !secondarySideBarDataTag) {
          dispatch(setActiveModal('createNewComponentModal'));
        }
        if (primarySideBarDataTag === 'lift' && secondarySideBarDataTag === 'Lift') {
          dispatch(setActiveModal('createNewComponentModal'));
        }
        if (primarySideBarDataTag === 'lift' && secondarySideBarDataTag === 'SAQ+C') {
          dispatch(setActiveModal('createNewComponentModal', { type: 'R' }));
        }
        if (primarySideBarDataTag === 'lift' && secondarySideBarDataTag === 'Circuit') {
          dispatch(setActiveModal('createNewComponentModal', { type: 'C' }));
        }
        if (primarySideBarDataTag === 'lift' && secondarySideBarDataTag === 'Warm-Up') {
          dispatch(setActiveModal('createNewComponentModal', { type: 'W' }));
        }
        if (primarySideBarDataTag === 'lift' && secondarySideBarDataTag === 'Notes') {
          dispatch(setActiveModal('createNewComponentModal', { type: 'N' }));
        }
        if (primarySideBarDataTag === 'lift' && secondarySideBarDataTag === 'Questionnaire') {
          dispatch(setActiveModal('createNewComponentModal', { type: 'S' }));
        }
        if (primarySideBarDataTag === 'lift' && secondarySideBarDataTag === 'Cooldown') {
          dispatch(setActiveModal('createNewComponentModal', { type: 'CD' }));
        }
      }
    };

    /** Add event listener on mount */
    window.addEventListener('keydown', handleKeyDown);
    /** Cleanup the event listener on unmount */
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [primarySideBarDataTag, secondarySideBarDataTag]);

  /** every time primarySideBarDataTag changes set secondary to null */
  useEffect(() => {
    dispatch(setSecondarySideBarDataTag(null));
  }, [primarySideBarDataTag]);

  const iconArray = [
    {
      name: 'Lift',
      id: 'Lift',
      icon: 'lift',
      iconColor: '#6C7A89',
      containerColor: 'rgba(108, 122, 137, 0.2)',
    },
    {
      name: 'SAQ+C',
      id: 'SAQ+C',
      icon: 'cardio',
      iconColor: '#59ABE3',
      containerColor: 'rgba(89, 171, 227, 0.2)',
    },
    {
      name: 'Circuit',
      id: 'Circuit',
      icon: 'circuit',
      iconColor: '#F89406',
      containerColor: 'rgba(248, 148, 6, 0.2)',
    },
    {
      name: 'Questionnaire',
      id: 'Questionnaire',
      icon: 'science',
      iconColor: '#9B59B6',
      containerColor: 'rgba(155, 89, 182, 0.2)',
    },
    {
      name: 'Health',
      id: 'Health',
      icon: 'heart',
      iconColor: '#E74C3C',
      containerColor: 'rgba(231, 76, 60, 0.2)',
    },
    {
      name: 'Notes',
      id: 'Notes',
      icon: 'note',
      iconColor: '#F9BF3B',
      containerColor: 'rgba(249, 191, 59, 0.2)',
    },
    {
      name: 'Warm-Up',
      id: 'Warm-Up',
      icon: 'warmup',
      iconColor: '#E74C3C',
      containerColor: 'rgba(231, 76, 60, 0.2)',
    },
    {
      name: 'Cooldown',
      id: 'Cooldown',
      icon: 'cooldown',
      iconColor: '#1787FB',
      containerColor: 'rgba(23, 135, 251, 0.2)',
    },
    {
      name: 'Tags',
      id: 'Tags',
      icon: 'tag2',
      iconColor: '#FF4500',
      containerColor: 'rgba(255, 69, 0, 0.2)',
    },
    {
      name: 'Progressions',
      id: 'Progressions',
      icon: 'chart',
      iconColor: '#FF00BF',
      containerColor: 'rgba(255, 0, 191, 0.2)',
    },
  ];

  /** commenting search realated funtionality out for now, will need later */
  const searchedExercises = iconArray?.filter((obj) => obj.name?.toLowerCase().includes(searchTerm.toLowerCase()));
  const searchedAccessoryItems = accessoryItems?.filter((obj) => obj.name?.toLowerCase().includes(searchTerm.toLowerCase()));

  const mainOptionsSlideOutAnimation = useSpring({
    /** add the padding from the surrounding sidebar to make sure it moves totatally out of view */
    marginLeft: showSecondLayerInfo ? `-${containerWidth + 16}` : '0px',
    width: '100%',
    height: '100%',
    maxWidth: windowWidth < 768 ? '100%' : '384px',
    display: 'flex',
    background: colors.surface,
    config: {
      duration: 250,
      easing: easings?.easeInOutQuad,
    },
    immediate: isResizing, /** Prevent animation when activeItem is false */
  });

  const secondLayerSlideOutAnimation = useSpring({
    /** add the padding from the surrounding sidebar to make sure it moves totatally out of view */
    marginLeft: showThirdLayerInfo ? `-${containerWidth + 16}` : '0px',
    width: '100%',
    height: '100%',
    maxWidth: windowWidth < 768 ? '100%' : '384px',
    display: 'flex',
    background: colors.surface,
    config: {
      duration: 250,
      easing: easings?.easeInOutQuad,
    },
    immediate: isResizing, /** Prevent animation when activeItem is false */
  });

  const secondLayerTransitions = useTransition(!!showSecondLayerInfo, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 1 },
    config: (state) => (state === 'leave' ? { duration: 0 } : { duration: 250 }),
  });

  const thirdLayerTransitions = useTransition(!!showThirdLayerInfo, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 1 },
    config: (state) => (state === 'leave' ? { duration: 0 } : { duration: 250 }),
  });

  const shimmerComponents = Array.from({ length: 13 }).map((_, index) => (
    <Shimmer key={index}>
      <ExerciseItemShimmerStrip />
    </Shimmer>
  ));

  return (
    <>
      <TitleContainer>
        <ExpandedTitlesContainer ref={expandedTitlesContainerHeightRef}>
          <HoverTextContainer>
            <Text
              onClick={() => {
                setShowThirdLayerInfo(false);
                setShowSecondLayerInfo(false);
                dispatch(setSecondarySideBarDataTag(null));
                dispatch(setSideBarExerciseSearchTerm(''));
              }}
              fontWeight={700}
              fontSize='13px'
              style={{
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: `${sideBarContainerWidth - 82}px`,
              }}
            >
              <SideBarTitleWrapper />
            </Text>
          </HoverTextContainer>
          {!!showSecondLayerInfo && (
          <>
            <Text
              fontSize='13px'
              fontWeight={700}
              style={{
                marginLeft: '5px', marginRight: '5px', display: 'inline-block', transform: 'rotate(15deg)',
              }}
            >
              /
            </Text>
            {showThirdLayerInfo ? (
              <HoverTextContainer>
                <Text
                  onClick={() => setShowThirdLayerInfo(false)}
                  style={{
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: `${sideBarContainerWidth - 82}px`,
                  }}
                  fontSize='13px'
                  color={colors.text}
                  fontWeight={showThirdLayerInfo ? 700 : 400}
                >
                  {showSecondLayerInfo}
                </Text>
              </HoverTextContainer>
            ) : (
              <Text
                style={{
                  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: `${sideBarContainerWidth - 82}px`,
                }}
                color={colors.textSecondary}
                fontSize='13px'
                fontWeight={showThirdLayerInfo ? 700 : 400}
              >
                {showSecondLayerInfo}
              </Text>
            )}
          </>
          )}
          {!!showThirdLayerInfo && (
          <>
            <Text
              fontSize='13px'
              fontWeight={700}
              style={{
                marginLeft: '5px', marginRight: '5px', display: 'inline-block', transform: 'rotate(15deg)',
              }}
            >
              /
            </Text>
            <Text
              fontSize='13px'
              color={colors.textSecondary}
              style={{
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: `${sideBarContainerWidth - 82}px`,
              }}
            >
              {showThirdLayerInfo?.name}
            </Text>
          </>
          )}
        </ExpandedTitlesContainer>
        {showSecondLayerInfo === 'Lift' && (
        <IcomoonReact
          iconSet={iconSet}
          size={16}
          icon='filter2'
          color={colors.textSecondary}
          style={{
            cursor: 'pointer',
            minWidth: '15px',
          }}
          onClick={() => setShowTagFilterDropdown(!showTagFilterDropdown)}
        />
        )}
      </TitleContainer>
      <AnimationWrapper>
        <ResizeObserver
          onResize={(rect) => {
            setContainerWidth(rect?.width);
          }}
        />
        <animated.div
          key='first-layer'
          style={{
            ...mainOptionsSlideOutAnimation,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          <Wrapper>
            {/* commenting this search bar out for now, we might need it for furture functionality}
            {/* <SearchAndIcon id='search-container' onClick={() => setIsSearchFocused(true)} isFocused={isSearchFocused}>
              <SearchIconContainer id='search-icon-container'>
                <IcomoonReact
                  iconSet={iconSet}
                  size={18}
                  icon='magnifying-glass-alt'
                  color={colors.textSecondary}
                />
              </SearchIconContainer>
              <SearchContainer
                placeholder='Search for an exercise'
                id='search-container-input'
                value={searchTerm}
                onFocus={() => setIsSearchFocused(true)}
                onChange={(inputValue) => {
                  setSearchTerm(inputValue.target.value);
                }}
              />
              {searchTerm && (
              <IcomoonReact
                iconSet={iconSet}
                size={15}
                icon='remove'
                color={colors.textSecondary}
                style={{ marginRight: 10, cursor: 'pointer' }}
                onClick={() => setSearchTerm('')}
              />
              )}
            </SearchAndIcon> */}
            <ExerciseWrapper sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight}>
              {isAllExercisesLoading ? (
                <>
                  {shimmerComponents}
                </>
              ) : (
                <MappedComponents>
                  <SearchedExercisesContainer>
                    {searchedExercises?.map((obj) => (
                      <ExerciseItemContainer
                        onClick={() => {
                          if (obj.type !== 'accessory') {
                            setShowSecondLayerInfo(obj.id);
                            dispatch(setSecondarySideBarDataTag(obj.id));
                          }
                        }}
                      >
                        <ExerciseNameAndIconWrapper>
                          <IconBox backgroundColor={obj.containerColor} borderColor={obj.borderColor}>
                            <IcomoonReact
                              iconSet={iconSet}
                              size={16}
                              icon={obj.icon}
                              color={obj.iconColor}
                            />
                          </IconBox>
                          <Text>{obj.name}</Text>
                        </ExerciseNameAndIconWrapper>
                        <IcomoonReact
                          iconSet={iconSet}
                          size={10}
                          icon='altrightarrow'
                          color={colors.textSecondary}
                        />
                      </ExerciseItemContainer>
                    ))}
                  </SearchedExercisesContainer>
                  <Separator />
                  <AccessoryDraggableItemsContainer accessoryDraggableItems={searchedAccessoryItems} sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
                  {/** commenting this out for now we might need this item for later */}
                  {/* <ExerciseItemContainer
                    onClick={() => {
                      dispatch(setActiveModal('createNewComponentModal'));
                    }}
                  >
                    <ExerciseNameAndIconWrapper>
                      <IconBox backgroundColor={colors.surface} borderColor={colors.borderLight}>
                        <IcomoonReact
                          iconSet={iconSet}
                          size={10}
                          icon='plus'
                          color={colors.textSecondary}
                        />
                      </IconBox>
                      <Text>Create New Exercise</Text>
                    </ExerciseNameAndIconWrapper>
                    {sideBarContainerWidth > 383 && (
                      <Text fontSize='16px' color={colors.textSecondary}>Shift+Enter</Text>
                    )}
                  </ExerciseItemContainer> */}
                </MappedComponents>
              )}
            </ExerciseWrapper>
            <ExerciseDataBaseButton onClick={() => {
              dispatch(setActiveModal('createNewComponentModal'));
            }}
            />
          </Wrapper>
        </animated.div>
        {secondLayerTransitions.map(({ item, props }) => (
          item && (
          <animated.div
            key='second-layer'
            style={{
              ...props,
              ...secondLayerSlideOutAnimation,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            {showSecondLayerInfo === 'Warm-Up' && (
              <WarmUpExercisesContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
            {showSecondLayerInfo === 'SAQ+C' && (
              <SACQContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
            {showSecondLayerInfo === 'Lift' && (
              <LiftExercisesContainer setShowThirdLayerInfo={setShowThirdLayerInfo} sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} showTagFilterDropdown={showTagFilterDropdown} />
            )}
            {showSecondLayerInfo === 'Circuit' && (
              <CircuitsContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
            {showSecondLayerInfo === 'Notes' && (
              <NotesContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
            {showSecondLayerInfo === 'Questionnaire' && (
              <QuestionnairesContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
            {showSecondLayerInfo === 'Cooldown' && (
              <CooldownContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
            {showSecondLayerInfo === 'Health' && (
              <HealthContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
            {showSecondLayerInfo === 'Progressions' && (
              <ProgressionsContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
            {showSecondLayerInfo === 'Tags' && (
              <TagsContainer sideBarContainerHeight={sideBarContainerHeight} expandedTitlesContainerHeight={expandedTitlesContainerHeight} sideBarContainerWidth={sideBarContainerWidth} windowWidth={windowWidth} />
            )}
          </animated.div>
          )))}
        {thirdLayerTransitions.map(({ item, props }) => (
          item && (
          <animated.div
            key='third-layer'
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              ...props,
            }}
          >
            {showThirdLayerInfo?.exerciseForm && (
            <Text style={{
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px',
            }}
            >
              {showThirdLayerInfo?.name}
            </Text>
            )}
          </animated.div>
          )))}
      </AnimationWrapper>
    </>
  );
};

export default ExercisesSideBarContent;
